import { render, staticRenderFns } from "./StatusHistory.vue?vue&type=template&id=4e973bdc"
import script from "./StatusHistory.vue?vue&type=script&lang=js"
export * from "./StatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e973bdc')) {
      api.createRecord('4e973bdc', component.options)
    } else {
      api.reload('4e973bdc', component.options)
    }
    module.hot.accept("./StatusHistory.vue?vue&type=template&id=4e973bdc", function () {
      api.rerender('4e973bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/compensatoryService/StatusHistory.vue"
export default component.exports